import { Col, Row } from 'antd';
import { useFormikContext } from 'formik';
import { useTranslation } from 'react-i18next';
import { FinanceProductType } from '../../../../../api/types';
import FormFields from '../../../../../themes/admin/Fields/FormFields';
import { type FinanceProductFormValues } from '../index';
import YesNoField from './YesNoField';

const colSpan = { lg: 8, xs: 24 };

const Term = ({ disabled = false }: { disabled?: boolean }) => {
    const { t } = useTranslation(['financeProductDetails']);
    const { values } = useFormikContext<FinanceProductFormValues>();

    const { term } = values;
    const { min = 0, max = 0 } = term;

    const isDeferredPrincipal = values.type === FinanceProductType.DeferredPrincipal;

    return (
        <Row gutter={[16, 16]}>
            <>
                <Col {...colSpan}>
                    <FormFields.InputNumberField
                        {...t('financeProductDetails:fields.termMin', { returnObjects: true })}
                        disabled={disabled}
                        min={0}
                        name="term.min"
                        precision={0}
                        required
                    />
                </Col>
                <Col {...colSpan}>
                    <FormFields.InputNumberField
                        {...t('financeProductDetails:fields.termMax', { returnObjects: true })}
                        disabled={disabled}
                        min={0}
                        name="term.max"
                        precision={0}
                        required
                    />
                </Col>
                <Col {...colSpan}>
                    <FormFields.InputNumberField
                        {...t('financeProductDetails:fields.termStep', { returnObjects: true })}
                        disabled={min >= max || disabled}
                        min={0}
                        name="term.step"
                        precision={0}
                        required
                    />
                </Col>
                <Col {...colSpan}>
                    <FormFields.InputNumberField
                        {...t('financeProductDetails:fields.termDefault', { returnObjects: true })}
                        disabled={disabled}
                        min={0}
                        name="term.default"
                        precision={0}
                        required
                    />
                </Col>
                {isDeferredPrincipal && (
                    <Col {...colSpan}>
                        <FormFields.InputNumberField
                            {...t('financeProductDetails:fields.interestOnly', { returnObjects: true })}
                            disabled={disabled}
                            min={0}
                            name="term.interestOnly"
                            required
                        />
                    </Col>
                )}
            </>
            <Col {...colSpan}>
                <YesNoField
                    {...t('financeProductDetails:fields.termViewable', { returnObjects: true })}
                    disabled={disabled}
                    name="term.isViewable"
                />
            </Col>
            <Col {...colSpan}>
                <YesNoField
                    {...t('financeProductDetails:fields.termEditable', { returnObjects: true })}
                    disabled={!term?.isViewable || disabled}
                    name="term.isEditable"
                />
            </Col>
        </Row>
    );
};

export default Term;
